export default {
  'meta': {
    'langName': 'SLOVENIAN',
    'lang': 'Slovenščina'
  },
  'emailConfirmation': {
    'title': 'Najprej vas prosimo, da potrdite svoj e-poštni naslov in državo, kjer bivate.'
  },
  'fields': {
    'country': 'Država',
    'address': 'E-poštni naslov',
    'email': 'E-poštni naslov',
    'phonePrefix': 'Klicna številka',
    'phone': 'Telefonska številka',
    'validations': {
      'phoneOrEmail': 'Prosimo, navedite vsaj en e-poštni naslov ali telefonsko številko.',
      'email': 'Prosimo, vnesite veljaven e-poštni naslov',
      'phone': 'Prosimo, vnesite veljavno telefonsko številko'
    },
    'firstName': 'Priimek',
    'lastName': 'Ime',
    'deliveryAddress': 'Naslov za pošiljanje paketa',
    'additionalAddress': 'Dodatni podatki o naslovu',
    'city': 'Kraj',
    'zip': 'Poštna številka',
    'choose': 'Izberi',
    'required': 'Polje je obvezno'
  },
  'yes': 'DA',
  'no': 'NE',
  'ownerChanged': {
    'title': 'Ali imate kontaktne podatke trenutnih lastnikov?',
    'confirmation': 'Spoštovani,\n\nzahvaljujemo se vam za sodelovanje v vprašalniku za zagotavljanje kakovosti.\n\nOpravičujemo se za povzročene nevšečnosti in zahvaljujemo za izkazano zaupanje.\n\nDECATHLON'
  },
  'recall': {
    'quantity': 'Število'
  },
  'repair': {
    'title': 'Popravilo z vašo pomočjo',
    'videoLink': 'Povezava do posnetka',
    'store': 'Povezava do navodil'
  },
  'form': {
    'submit': 'Naprej'
  },
  'status': 'Translation validated by COUNTRY'
} as const
